import clsx from 'clsx';
import { Button, Dropdown } from 'antd';

import { IconSortMenu } from '../../Icon';
import { PostListParams } from '../../../../store/post/list';

import styles from './index.module.scss';

interface PostListSortByProps {
  onChange: (filter: Pick<PostListParams, 'orderBy' | 'orderByColumn'>) => void;
  orderBy: PostListParams['orderBy'];
  orderByColumn: PostListParams['orderByColumn'];
}

const PostListSortBy = ({
  onChange,
  orderBy,
  orderByColumn,
}: PostListSortByProps) => (
  <Dropdown
    placement="bottomRight"
    menu={{
      items: [
        {
          key: '0',
          label: 'Most recent',
          onClick: () =>
            onChange({ orderBy: 'DESC', orderByColumn: 'createdAt' }),
          className: clsx(
            orderBy === 'DESC' &&
              orderByColumn === 'createdAt' &&
              styles.activeItem
          ),
        },
        {
          key: '1',
          label: 'Most popular',
          onClick: () =>
            onChange({ orderBy: 'DESC', orderByColumn: 'numberOfLikes' }),
          className: clsx(
            orderBy === 'DESC' &&
              orderByColumn === 'numberOfLikes' &&
              styles.activeItem
          ),
        },
      ],
    }}
    trigger={['click']}
  >
    <Button size="large" className={styles.menuButton}>
      <IconSortMenu /> Sort by
    </Button>
  </Dropdown>
);

export default PostListSortBy;
